module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ot7_golden_ticket_hero.5c4a90a0.webp";